{
  "ascending": "nouseva",
  "ascendingSort": "lajiteltu sarakkeen {columnName} mukaan nousevassa järjestyksessä",
  "columnSize": "{value} pikseliä",
  "descending": "laskeva",
  "descendingSort": "lajiteltu sarakkeen {columnName} mukaan laskevassa järjestyksessä",
  "resizerDescription": "Aloita koon muutos painamalla Enter-näppäintä",
  "select": "Valitse",
  "selectAll": "Valitse kaikki",
  "sortable": "lajiteltava sarake"
}
